/* eslint-disable react/jsx-wrap-multilines */
import { PudoLocation } from '@pperform/pp-data-mappers';
import { DropOffLocationsLayout } from '../../../../DropOffLocationLayout';
import { searchDropOffLocations } from '../../../services';
import { Container } from './ChooseDropOffLayout.styles';

interface ChooseDropOffLayoutProps {
  isShow: boolean;
  goToNextStep: () => void;
  onSaveDropOffLocation: (dropOff: PudoLocation) => void;
}

const ChooseDropOffLayout = ({
  isShow,
  goToNextStep,
  onSaveDropOffLocation,
}: ChooseDropOffLayoutProps): JSX.Element => {
  const onSelectDropOff = (data: PudoLocation) => {
    onSaveDropOffLocation(data);
    goToNextStep();
  };

  return (
    <Container isShow={isShow}>
      <DropOffLocationsLayout
        searchDropOffLocationsFn={searchDropOffLocations}
        onSelectDropOff={onSelectDropOff}
      />
    </Container>
  );
};

export { ChooseDropOffLayout };
